import { c as _c } from "react/compiler-runtime";
import { Button } from '@/shared/components/ui/common/Button';
import { Plus } from 'lucide-react';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/features/extrajudicial/components/ui/dropdown-menu';
interface ButtonWithDropdownOption {
  title: string;
  action: () => void;
  description: string;
  icon: React.ReactNode;
}
export function ButtonWithDropdown(t0) {
  const $ = _c(13);
  const {
    title,
    options,
    rightIcon
  } = t0;
  const t1 = rightIcon || undefined;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Plus className="h-4 w-4" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <div className="flex items-center gap-2">{t2}<span>{title}</span></div>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t1 || $[4] !== t3) {
    t4 = <DropdownMenuTrigger asChild={true}><Button variant="brand-primary" size="medium" className="w-full px-3 py-2 text-xs sm:w-auto sm:px-4 sm:text-sm" iconRight={t1}>{t3}</Button></DropdownMenuTrigger>;
    $[3] = t1;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== options) {
    t5 = options.map(_temp);
    $[6] = options;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <DropdownMenuContent align="end" className="w-80 rounded-lg border-zinc-200 bg-white p-2 shadow-lg">{t5}</DropdownMenuContent>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <DropdownMenu>{t4}{t6}</DropdownMenu>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
}
function _temp(option, index) {
  return <DropdownMenuItem key={index} onClick={option.action} className="mb-1 cursor-pointer rounded-md p-4 transition-colors outline-none hover:bg-blue-50 focus:bg-blue-50"><div className="flex w-full items-start gap-3"><div className="flex-shrink-0 rounded-md bg-blue-100 p-2">{option.icon}</div><div className="flex-1"><div className="mb-1 text-sm leading-tight font-semibold text-gray-900">{option.title}</div><div className="text-xs leading-relaxed text-gray-600">{option.description}</div></div></div></DropdownMenuItem>;
}